import React, { useState } from "react";
import HeroFooter from "../components/footer";
import "./about.css";
import { motion } from "framer-motion";
import qrCode from "../assets/images/qrcode1.jpeg";
import ReCAPTCHA from "react-google-recaptcha";
import logo from "../assets/images/logo.png"
import logo2 from "../assets/images/indulogodubai.png"

function Contact() {
  const [captchaToken, setCaptchaToken] = useState("");

  const slideLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 1 } },
  };

  const slideRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 1 } },
  };

  return (
    <div>
      <section className="contacthead">
        {/* APPOINTMENT SECTION */}
        <div className="appointment-container">
          <motion.h2
            className="appointment-heading"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.8 }}
          >
            Book Your Appointment
          </motion.h2>
          <div className="appointment-content">
            <motion.div
              className="appointment-steps"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              variants={slideLeft}
            >
              <h3>How It Works</h3>
              <ol>
                <li>Scan the QR code to pay Rs. 1000 for a 60-minute appointment.</li>
                <li>After payment, click "Book Now" below.</li>
                <li>You’ll be redirected to our Google Calendar to schedule your slot.</li>
              </ol>
              <p className="appointment-note">
                (Please note: Payment confirmation is required to activate the booking.)
              </p>
            </motion.div>

            <motion.div
              className="appointment-qr"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              variants={slideRight}
            >
              <img src={qrCode} alt="QR Code for Payment" className="qr-image" />
              <a
                href="https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ2_Mc65EfnAdZ7aqjw5flRhd4Unb10xUpnP6LOzctpj5G-oHkFCUQc9tPx8TI0ThbAo8u_cc4Aa"
                target="_blank"
                rel="noopener noreferrer"
                className="book-now-btn"
              >
                Book Appointment Now
              </a>
            </motion.div>
          </div>
        </div>

        {/* CONTACT SECTION */}
        <div className="contact-section">
          <div className="contact-inner">
            <motion.div
              className="contact-left"
              initial={{ opacity: 0, x: -100 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
            >
             <div className="left-overlay">
  <h2>Contact Us</h2>

  {/* India Address Block */}
  <div className="address-block">
    <div className="address-text">
      <p>
         <strong style={{ color: "#c79c61" }}>Address :</strong><br />
       Office No. 604, 6th. Floor,<br/> Fortuna Business Centre,<br/> Survey No. 122 Pimple Saudagar,<br/> Pune, Maharashtra, India- 411027
      </p>
      <p><strong style={{ color: "#c79c61" }}>Phone:</strong> +91 9876543210</p>
      <p><strong style={{ color: "#c79c61" }}>Email:</strong> info@induratnalaw.com</p>
    </div>
    <a href="/">
    <img
      src={logo} // ✅ Replace with your actual image path
      alt="India Office"
      className="branch-logo"
    /></a>
  </div>

  {/* Dubai Address Block */}
  <div className="address-block">
    {/* <div className="address-text">
      <p>
        <strong style={{ color: "#c79c61" }}>Dubai Address:</strong><br />
        <a
          href="https://www.asklogics.com/dubai-branch/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#87CEEB" }}
        >
          asklogics.com/dubai-branch
        </a><br />
        Office No. 103 A-2<br />
        Frij Al Marrar Building, Al Mararr, Deira,<br />
        Dubai, U.A.E
      </p>
    </div> */}
    {/* <a href="https://www.asklogics.com/dubai-branch/">
    <img
      src= {logo2}
      alt="Dubai Office"
      className="branch-logo"
    /></a> */}
  </div>
</div>

            </motion.div>

            <motion.div
              className="contact-right"
              initial={{ opacity: 0, x: 100 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.2 }}
            >
              <div className="form-container">
                <h2>Get In Touch</h2>
                <form
                  action="https://demo.satkarnewserver.com/induratnareact/php/enquiry.php"
                  method="POST"
                  encType="application/x-www-form-urlencoded"
                >
                  <div className="input-group">
                    <input type="text" name="name" placeholder="Your Name" required />
                  </div>
                  <div className="input-group">
                    <input type="email" name="email" placeholder="Your Email" required />
                  </div>
                  <div className="input-group">
                    <input type="tel" name="phone" placeholder="Your Phone" required />
                  </div>
                  <div className="input-group">
                    <input type="text" name="subject" placeholder="Subject" />
                  </div>
                  <div className="input-group">
                    <textarea name="message" placeholder="Your Message" required></textarea>
                  </div>

                  {/* 👇 RECAPTCHA INTEGRATION */}
                  <div className="input-group">
                    <ReCAPTCHA
                      sitekey="6LftcRsrAAAAAIdlKq7Ix1smdtKGeo_aLWESowbC"
                      onChange={(token) => setCaptchaToken(token)}
                    />
                    {/* Hidden input to send token to backend */}
                    <input type="hidden" name="g-recaptcha-response" value={captchaToken} />
                  </div>

                  <button type="submit" className="btn-submit">Send Message</button>
                </form>
              </div>
            </motion.div>
          </div>

          <motion.div
            className="map-section"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <iframe
              title="Our Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3781.8229422222335!2d73.8163418!3d18.5820195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b9481eb1d05d%3A0xfa0df3dcb2762e19!2sInduRatna%20Law%20Associates!5e0!3m2!1sen!2sin!4v1743681989854!5m2!1sen!2sin"
              allowFullScreen
            ></iframe>
          </motion.div>
        </div>
      </section>
      <HeroFooter />
    </div>
  );
}

export default Contact;
